// Cloudflare R2 Upload Utility for Admin Panel
// Uploads files to backend for R2 storage

const uploadToR2 = async (file, resourceType) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('resourceType', resourceType);

    // Validate file size (50MB max for resources)
    const maxSize = 50 * 1024 * 1024; // 50MB
    if (file.size > maxSize) {
      throw new Error('File size must be less than 50MB');
    }

    // Validate file type based on resource type
    const allowedTypes = {
      'PDF': ['application/pdf'],
      'VIDEO': ['video/mp4', 'video/webm', 'video/ogg'],
      'IMAGE': ['image/jpeg', 'image/png', 'image/gif', 'image/webp']
    };

    const typeAllowed = allowedTypes[resourceType] || [];
    if (typeAllowed.length > 0 && !typeAllowed.includes(file.type)) {
      throw new Error(`Invalid file type for ${resourceType}. Expected: ${typeAllowed.join(', ')}`);
    }

    // Upload to backend which will handle R2 storage
    const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:4000'}/api/v1/upload/learning-resource`, {
      method: 'POST',
      body: formData,
      headers: {
        // Don't set Content-Type - let browser set it for FormData
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Upload failed');
    }

    const result = await response.json();

    return result.url;
  } catch (error) {
    throw error;
  }
};

export default uploadToR2;
